import Alert from 'react-bootstrap/Alert';
import BeatLoader from 'react-spinners/BeatLoader';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Modal from 'react-bootstrap/Modal';
import React, { Component } from 'react';
import SearchInput from '../../shared/SearchInput';
import UserExceptionGrid from './UserExceptionGrid';
import { BPagination } from '../../shared/Pagination';
import { LoadingStyle } from '../../../styles';
import {
    addUserException,
    updateAddErrorMsg,
    deleteUserException,
    fetchUserExceptionData,
} from '../../../actions/admin/userException.action';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { withRouter } from 'react-router-dom';

class UserException extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            searchTerm: '',
            showNewItemModal: false,
            userId: '',
            validated: false,
            errorNewItem: '',
            currentPage: 1,
            itemsPerPage: 10,
        };
        this.formRef = React.createRef();
    }

    componentDidMount() {
        if (this.props.authState.isAuthenticated) {
            this.props.fetchUserExceptionData(this.props.authState.accessToken.accessToken);
        }
    }

    delete_handler(userId) {
        if (!userId) return;

        this.setState({ ...this.state, show: true, userIdDelete: userId });

    }

    confirmDelete_handler() {
        if (!this.state.userIdDelete) return;

        this.props.deleteUserException({ userId: this.state.userIdDelete, jwt: this.props.authState?.accessToken?.accessToken });
        this.setState({ ...this.state, show: false, userIdDelete: undefined });
    }

    cancelDelete_handler() {

        this.setState({ ...this.state, show: false, userIdDelete: undefined });
    }

    handleOpenNewItemModal() {
        this.props.updateAddErrorMsg('');
        this.setState({ ...this.state, showNewItemModal: true, userId: '' });

    }

    handleSearch(searchTerm) {
        console.log('Search term:', searchTerm);
        this.setState({ ...this.state, searchTerm, currentPage: 1 });
    }

    handleCancelNewItem() {
        this.props.updateAddErrorMsg('');
        this.setState({ ...this.state, showNewItemModal: false, userId: '' });
    }

    handleSaveNewItem() {
        if (!this.state.userId) return;

        if (!this.validateEmail(this.state.userId)) {
            this.setState({ ...this.state, errorNewItem: 'Please enter a valid email.', validated: true });
            return;
        }

        this.props.updateAddErrorMsg('');
        this.props.addUserException({ userId: this.state.userId, jwt: this.props.authState?.accessToken?.accessToken });
        this.setState({ ...this.state, showNewItemModal: false, userId: '' });
    }

    validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };


    handleOnInputChange(e) {
        this.props.updateAddErrorMsg('');
        this.setState({ ...this.state, userId: e.target.value });
    }


    filterData(data) {
        if (!this.state.searchTerm) return data;

        return data.filter((item) => Object.values(item).some((value) => value.toLowerCase().includes(this.state.searchTerm.toLowerCase())));
    }


    handlePaginate(pageNumber) {
        this.setState({ ...this.state, currentPage: pageNumber });
    }


    renderDeleteModal() {
        return (<Modal show={this.state.show} onHide={() => this.setState({ ...this.state, show: false })}>
            <Modal.Header>
                <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>This will delete the user permanently. You cannot undo this action.</Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={this.cancelDelete_handler.bind(this)}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={this.confirmDelete_handler.bind(this)}>
                    Delete
                </Button>
            </Modal.Footer>
        </Modal>);
    }

    renderAddModal() {
        return (<Modal show={this.state.showNewItemModal}>
            <Modal.Header>
                <Modal.Title>Add New Record</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <InputGroup hasValidation>
                    <Form.Control type="email" isInvalid={(this.props.newItemError || this.state.errorNewItem)} required
                                  value={this.state.userId} onChange={(e) => this.handleOnInputChange(e)} />
                    <Form.Control.Feedback type="invalid">
                        {this.props.newItemError || this.state.errorNewItem || 'Please enter a valid email.'}
                    </Form.Control.Feedback>
                </InputGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={this.handleCancelNewItem.bind(this)}>
                    Cancel
                </Button>
                <Button variant="success" onClick={() => this.handleSaveNewItem()}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>);
    }

    renderAlert() {
        return this.props.newItemError ? <Alert show={this.state.alerOpen} variant="danger">
            <p>
                {this.props.newItemError}
            </p>
        </Alert> : <></>;
    }

    render() {
        const { data, loading, error } = this.props;

        const filteredData = this.filterData(data) || [];

        const itemsPerPage = 10;
        const indexOfLastItem = this.state.currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;

        const paginatedData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

        return (<div>
            <div className="main-panel main-panel-analytics">
                <div className="container">
                    <div className="page-inner">
                        <h4 className="page-title"></h4>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title mb-3">Zoom License Exceptions</h5>
                                        <h6 className="card-subtitle mb-2 text-muted">DB used for managing Zoom
                                            licenses</h6>
                                    </div>
                                    <div className="card-body">
                                        {loading ? (
                                            <BeatLoader css={LoadingStyle} size={12} color={'#1C23BA'} loading={true}
                                                        speedMultiplier={0.8} />) : <span />}
                                        {this.renderAlert()}
                                        <SearchInput onSearch={this.handleSearch.bind(this)} />

                                        <UserExceptionGrid items={paginatedData}
                                                           onDelete={this.delete_handler.bind(this)}
                                                           onAdd={this.handleOpenNewItemModal.bind(this)} />
                                        <div className="row">
                                            <div className="col-md-4 offset-md-8">
                                                <BPagination paginate={(pageNumber) => this.handlePaginate(pageNumber)}
                                                             currentPage={this.state.currentPage}
                                                             itemsPerPage={this.state.itemsPerPage}
                                                             totalItems={filteredData?.length || 0} />
                                            </div>
                                        </div>
                                        {this.renderDeleteModal()}
                                        {this.renderAddModal()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => ({
    data: state.userException.data,
    loading: state.userException.loading,
    error: state.userException.error,
    deleteItemError: state.userException.deleteItemError,
    newItemError: state.userException.newItemError,
});


export default compose(withRouter, withOktaAuth, connect(mapStateToProps, {
    fetchUserExceptionData, addUserException, deleteUserException, updateAddErrorMsg,
}))(UserException);